<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { generateId } from '@client/utils/generate-id';

  import { ADDIN_FEATURES } from '@client/enums';

  export let domain = {};

  const { domainsettings, features, outlookaddin, outlookAddinVersions, stamped } = domain;

  const id = generateId();

  const getEntry = (key, value) => {
    const feature = $format(ADDIN_FEATURES[key].label);
    const inverted = ADDIN_FEATURES[key].inverted ? !value : value;

    if (value === undefined) {
      return '';
    }

    if (typeof value === 'boolean') {
      return `${feature}: ${inverted ? $format('label.ON') : $format('label.OFF')}`;
    }

    return `${feature}: "${value}"`;
  };
</script>

<div class="tag features" id="domain-features-{id}">
  <Icon name="settings" />
  {$format('label.FEATURES')}
  <Tooltip target="domain-features-{id}" placement="top">
    <b>{$format('label.ENABLED')}</b>
    <ul>
      {#if features.enableautoinlining}
        <li>{$format('label.AUTO_INLINING')}</li>
      {/if}
      {#if !features.disablebanners}
        <li>{$format('label.BANNERS')}</li>
      {/if}
      {#if !features.disablemydocuments}
        <li>{$format('label.DOCUMENTS')}</li>
      {/if}
      {#if features.enableinlineads}
        <li>{$format('label.INLINE_ADS')}</li>
      {/if}
      {#if features.enableinlineimages}
        <li>{$format('label.INLINE_IMAGES')}</li>
      {/if}
      <li>
        {#if domainsettings.enableadvancedtemplates}
          {$format('label.LIQUID_TEMPLATES')}
        {:else}
          {$format('label.LEGACY_TEMPLATES')}
        {/if}
      </li>
      <li>
        {#if domainsettings.enableadvancedviewer}
          {$format('label.NEW_PDF_VIEWER')}
        {:else}
          {$format('label.LEGACY_PDF_VIEWER')}
        {/if}
      </li>
      {#if features.enablemysignature}
        <li>{$format('label.MY_SIGNATURE')}</li>
      {/if}
      {#if features.enablesurveys}
        <li>{$format('label.SURVEYS')}</li>
      {/if}
      {#if features.enablegappsphotos || features.enableo365photos || features.enablebamboohrphotos}
        <li>{$format('label.THUMBNAIL_PHOTOS')}</li>
      {/if}
    </ul>

    <br />

    <b>{$format('label.DISABLED')}</b>
    <ul>
      {#if !features.enableautoinlining}
        <li>{$format('label.AUTO_INLINING')}</li>
      {/if}
      {#if features.disablebanners}
        <li>{$format('label.BANNERS')}</li>
      {/if}
      {#if features.disablemydocuments}
        <li>{$format('label.DOCUMENTS')}</li>
      {/if}
      {#if !features.enableinlineads}
        <li>{$format('label.INLINE_ADS')}</li>
      {/if}
      {#if !features.enableinlineimages}
        <li>{$format('label.INLINE_IMAGES')}</li>
      {/if}
      {#if !features.enablemysignature}
        <li>{$format('label.MY_SIGNATURE')}</li>
      {/if}
      {#if !features.enablesurveys}
        <li>{$format('label.SURVEYS')}</li>
      {/if}
      {#if !features.enablegappsphotos && !features.enableo365photos && !features.enablebamboohrphotos}
        <li>{$format('label.THUMBNAIL_PHOTOS')}</li>
      {/if}
    </ul>
  </Tooltip>
</div>

{#if outlookaddin}
  <div class="tag addin" id="domain-addin-{id}">
    <i class="os-icon-os-windows" />
    {$format('label.ADD_IN')}
    <!-- {#if outlookAddinVersions}
      v{outlookAddinVersions[outlookAddinVersions.length - 1]}
    {/if} -->
    <Tooltip target="domain-addin-{id}" placement="top">
      <b>{$format('label.FEATURES')}</b>
      <ul>
        {#each Object.keys(ADDIN_FEATURES) as key}
          <li>{getEntry(key, domainsettings.outlookaddin[key])}</li>
        {/each}
      </ul>

      <br />

      <div>
        <b>{$format('label.VERSIONS_LAST_60')}</b>
        <div>{outlookAddinVersions.map((version) => `v${version}`).join(', ')}</div>
      </div>
    </Tooltip>
  </div>
{/if}

{#if stamped}
  <div class="tag stamped" id="domain-stamped-{id}">
    <i class="os-icon-opensense" />
    {$format('label.STAMPED')}
    <Tooltip target="domain-stamped-{id}" placement="top">{$format('label.ACTIVE_STAMPING')}</Tooltip>
  </div>
{/if}

<style lang="scss" src="./features.scss"></style>
